import React from 'react';
import { Select } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useLanguage } from '../contexts/LanguageContext';

const { Option } = Select;

interface LanguageSelectorProps {
  style?: React.CSSProperties;
  size?: 'small' | 'middle' | 'large';
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ 
  style, 
  size = 'middle' 
}) => {
  const { currentLanguage, setLanguage, availableLanguages } = useLanguage();

  return (
    <Select
      value={currentLanguage}
      onChange={setLanguage}
      style={{ minWidth: 120, ...style }}
      size={size}
      suffixIcon={<GlobalOutlined />}
    >
      {availableLanguages.map((lang) => (
        <Option key={lang.code} value={lang.code}>
          {lang.nativeName}
        </Option>
      ))}
    </Select>
  );
};

export default LanguageSelector;
